import { UIActionType, UIAction } from '../../actions/uiActions';

const consoleTimestampReducer = (state = true, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_CONSOLE_TIMESTAMP:
      return !state;
    default:
      return state;
  }
};

export default consoleTimestampReducer;
